import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  REFRESH_TOKEN,
  REFRESH_TOKEN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SWITCH_ACCOUNT,
} from "./actionTypes"

export const loginUser = (user, afterLoginCB) => {
  return {
    type: LOGIN_USER,
    payload: { user, afterLoginCB },
  }
}

export const switchAccount = (newAccountId) => {
  return {
    type: SWITCH_ACCOUNT,
    payload: { newAccountId },
  }
}

export const loginSuccess = (user) => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}
export const refreshToken = () => {
  return {
    type: REFRESH_TOKEN,
  }
}

export const refreshTokenSuccess = (token) => {
  return {
    type: REFRESH_TOKEN_SUCCESS,
    payload: token,
  }
}

export const logoutUser = () => {
  return {
    type: LOGOUT_USER,
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  }
}
